import { combineReducers } from 'redux';

import assetAudit from './assetAudit';
import detection from './detection';
import enforcement from './enforcement';
import reporting from './reporting';
import socialMediaMessages from './socialMediaMessages';
import tasks from './tasks';
import validation from './validation';

const reducers = {
  assetAudit,
  detection,
  enforcement,
  reporting,
  tasks,
  validation,
  socialMediaMessages,
};

export default combineReducers(reducers);
